import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export default function Card({
  as: As = "div",
  className = "",
  hoverable = true,
  children,
  ...rest
}) {
  const reduceMotion = useReducedMotion();

  const inner = (
    <As
      className={`rounded-2xl border border-fk-border bg-fk-surface/80 shadow-[0_1px_0_rgba(0,0,0,0.02),0_18px_50px_rgba(11,18,32,0.08)] backdrop-blur dark:border-white/10 dark:bg-gray-900/60 dark:shadow-[0_1px_0_rgba(255,255,255,0.04),0_18px_50px_rgba(0,0,0,0.45)] ${className}`}
      {...rest}
    >
      {children}
    </As>
  );

  if (!hoverable) return inner;

  return (
    <motion.div
      initial={false}
      whileHover={reduceMotion ? undefined : { y: -6 }}
      transition={{ duration: 0.22, ease: "easeOut" }}
      className="h-full"
    >
      {inner}
    </motion.div>
  );
}

